// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"567":"61d86082","592":"94f897f2","596":"de3b7137"}[chunkId] + ".chunk.js";
};